import React from 'react';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../../Common/Header/header';
import KitTypesViewGrid from '../../KitTypesView/KitTypesViewGrid/kitTypesViewGrid';
import {MatSettingsMenuItemsIds} from '../../../../../enums/navigationMenuItemsIds';
import {gridsNames} from '../../../../../enums/gridsNames.js';


export default class ArchivedKitTypesView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.kittypes.view.');
  }

  componentDidMount() {
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_KIT_TYPES);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    let items =  {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id:'view',
          label: headerItemsLabels.VIEW,
          className: 'no-icon',
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: () => {
            this.props.history.push(`${this.props.match.url}/archived/kitTypeForm/${selectedRowsData.get(0)?.id}/view`)
          },
          actionData: selectedRowsData.get(0)
        },
      ],
      kebab: {
        menuItems: [
          {
            id:'exportKitTypes',
            label: headerItemsLabels.EXPORT_KIT_TYPES,
            action: actions.header.exportItems,
            disabled: !hasRows,
            actionData: {gridName: gridsNames.ADMINISTRATION_MAT_SETTINGS_ARCHIVED_KIT_TYPES}
          },
          {
            id:'exportOperationSequence',
            label: headerItemsLabels.EXPORT_OPERATION_SEQUENCE,
            action: actions.header.exportOperationSequence,
            disabled: !hasRows,
            actionData: {archived: true}
          },
        ]
      }
    };

    return items;
  }

  render() {
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <Header {...headerItems} />
        <KitTypesViewGrid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_ARCHIVED_KIT_TYPES}
          actions={{...this.props.actions.archivedKitTypesViewGridActions, ...this.props.actions.fetchEntitiesActions}}/>
      </div>
    );
  }
}
